import { useContext } from 'react';
import { store } from '../context';

export const useStore = () => useContext(store);
